var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{class:{
      task: _vm.task.task_type.id === 1,
      meeting: _vm.task.task_type.id === 2,
      announcement: _vm.task.task_sub_type
        ? _vm.task.task_sub_type.id === 4
        : _vm.taskIsAnnouncement(),
      openshift: _vm.task.task_sub_type
        ? _vm.task.task_sub_type.id === 5
        : _vm.taskIsOpenShift(),
      'email-task': _vm.task.task_type.id === 4,
      repeated: _vm.task.task_type.id === 5,
      outline: _vm.task.task_sub_type
        ? _vm.task.task_sub_type.id === 3
        : _vm.taskIsOutline(),
      'task-question': _vm.task.task_sub_type
        ? _vm.task.task_sub_type.id === 6
        : _vm.taskIsQuestion()
      // || taskIsOutline()
    },staticStyle:{"white-space":"nowrap"}},[_vm._v(_vm._s(_vm.getTitleForTaskTypeFromSubType()))])])}
var staticRenderFns = []

export { render, staticRenderFns }